import { useTranslation } from 'react-i18next';
import { getLandingContent } from '@/mocks/landingData';

export default function WhyUsSection() {
  const { i18n } = useTranslation();
  const { whyUs } = getLandingContent(i18n.language);

  return (
    <section id="why-us" className="py-20 md:py-28 bg-gray-50">
      <div className="px-6 md:px-10 lg:px-16">
        <div className="text-center mb-4">
          <p className="text-red-600 text-sm font-medium tracking-widest uppercase mb-4">
            {whyUs.eyebrow}
          </p>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 md:mb-6">
            {whyUs.title}
          </h2>
          <p className="text-base text-gray-500 max-w-2xl mx-auto mb-14 md:mb-20 leading-relaxed">
            {whyUs.subtitle}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6 max-w-5xl mx-auto">
          {whyUs.items.slice(0, 3).map((item) => (
            <div
              key={item.id}
              className="bg-white rounded-lg p-7 md:p-8 border border-gray-100 shadow-soft hover:shadow-card transition-shadow duration-300"
            >
              <div className="w-12 h-12 rounded-lg bg-red-50 flex items-center justify-center mb-5">
                <i className={`${item.icon} text-red-600 text-xl w-6 h-6 flex items-center justify-center`}></i>
              </div>
              <h3 className="text-lg md:text-xl font-semibold text-gray-900 mb-3 leading-snug">
                {item.title}
              </h3>
              <p className="text-sm text-gray-500 leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6 max-w-3xl mx-auto mt-5 md:mt-6">
          {whyUs.items.slice(3).map((item) => (
            <div
              key={item.id}
              className="bg-white rounded-lg p-7 md:p-8 border border-gray-100 shadow-soft hover:shadow-card transition-shadow duration-300"
            >
              <div className="w-12 h-12 rounded-lg bg-red-50 flex items-center justify-center mb-5">
                <i className={`${item.icon} text-red-600 text-xl w-6 h-6 flex items-center justify-center`}></i>
              </div>
              <h3 className="text-lg md:text-xl font-semibold text-gray-900 mb-3 leading-snug">
                {item.title}
              </h3>
              <p className="text-sm text-gray-500 leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
